import React from "react";
import { useTranslation } from "react-i18next";
import { chakraComponents } from "chakra-react-select";

const menuHeaderStyle = {
  padding: "8px 12px 0px 12px",
  background: "transparent",
  color: "gray.200",
  fontSize: "14px",
};

const CustomMenuList = (props) => {
  const { t } = useTranslation(["common"]);
  return (
    <chakraComponents.MenuList {...props}>
      <div style={menuHeaderStyle}>{t("custom_menu_msg")}</div>
      {props.children}
    </chakraComponents.MenuList>
  );
};

export default CustomMenuList;
